export const OtherPos = [
  {
    title: "Food Ambassador",
    email: "",
    people: ["Samvita Gautham"],
  },
  {
    title: "Technology Coordinator",
    email: "",
    people: ["interested?", "Contact the Jones President!"],
  },
  {
    title: "Student Maintenance Representative",
    email: "jp228@rice.edu",
    people: ["JT Parr"],
  },
  {
    title: "Senior Events Committee Council",
    email: "",
    people: [
      "Dyllan Lozano-Lomeli",
      "Nancy Martinez",
      "Samvita Gautham",
      "Abigail Li",
      "Safa Merani",
      "Eshika Tandon",
      "Ayden Lalani",
    ],
  },
  {
    title: "Public Space Coordinators",
    // "email": "dmr10@rice.edu",
    people: ["Interested?", "Reach out to the Jones President!"],
  },
  {
    title: "Head Caregivers",
    email: "",
    people: ["Franco Uribe", "Shivani Patel", "Lisa Wang"],
  },
  {
    title: "College Night Coordinators",
    email: "",
    people: ["Jud McGinnes", "Iris Rivera", "Banesa Valencia"],
  },
  {
    title: "Traditions Coordinators",
    email: "",
    people: ["JT Parr", "Brian Messar"],
  },
];
